/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Placeholder_UrlInputs */

const en_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const de_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const fr_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const es_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const it_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const nl_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const pl_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const fi_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const da_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

const sv_jobs_placeholder_url = /** @type {(inputs: Jobs_Placeholder_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.example.com/jobs/123`)
};

/**
* | output |
* | --- |
* | "https://www.example.com/jobs/123" |
*
* @param {Jobs_Placeholder_UrlInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_placeholder_url = /** @type {((inputs?: Jobs_Placeholder_UrlInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Placeholder_UrlInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_placeholder_url(inputs)
	if (locale === "fr") return fr_jobs_placeholder_url(inputs)
	if (locale === "es") return es_jobs_placeholder_url(inputs)
	if (locale === "it") return it_jobs_placeholder_url(inputs)
	if (locale === "nl") return nl_jobs_placeholder_url(inputs)
	if (locale === "pl") return pl_jobs_placeholder_url(inputs)
	if (locale === "fi") return fi_jobs_placeholder_url(inputs)
	if (locale === "da") return da_jobs_placeholder_url(inputs)
	if (locale === "sv") return sv_jobs_placeholder_url(inputs)
	return en_jobs_placeholder_url(inputs)
});